// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DynamicFormPicklistItemDefinitionModel from '../../model/dynamic-form-picklist-item-definition-model';
import DynamicFormPicklistItemDefinitionDTO from '../dto/dynamic-form-picklist-item-definition-dto';
import dtoSchema from '../schemas/dynamic-form-picklist-item-definition-schema';

export default abstract class DynamicFormPicklistItemDefinitionModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DynamicFormPicklistItemDefinitionDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.caption = data.caption ?? undefined;
      this.order = data.order;
    }
  }
  /**
  * @minimum 1
  */
  id?: string;
  /**
  */
  caption?: string;
  /**
  * @type {int32}
  */
  order?: number;

  static toModel(dto: DeepPartial<DynamicFormPicklistItemDefinitionDTO>): DynamicFormPicklistItemDefinitionModel;
  static toModel(dto: DeepPartial<DynamicFormPicklistItemDefinitionDTO> | undefined | null): DynamicFormPicklistItemDefinitionModel | undefined;
  static toModel(dto: DeepPartial<DynamicFormPicklistItemDefinitionDTO> | undefined | null): DynamicFormPicklistItemDefinitionModel | undefined {
    return dto ? new DynamicFormPicklistItemDefinitionModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DynamicFormPicklistItemDefinitionModel> | DynamicFormPicklistItemDefinitionModel): DynamicFormPicklistItemDefinitionDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      caption: unwrapped.caption,
      order: unwrapped.order,
    } as DynamicFormPicklistItemDefinitionDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DynamicFormPicklistItemDefinitionModel, can not map to DynamicFormPicklistItemDefinitionDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
